import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=2fb0a4b5&scoped=true"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"
import style0 from "./Authentication.vue?vue&type=style&index=0&id=2fb0a4b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0a4b5",
  null
  
)

export default component.exports